module.exports = __webpack_public_path__ + "media/images/event/event-template-ro-15f8ed0e5c5f57336480b2fca1c20c7d.png";